<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your <span v-if="showYourPartnerTab">partner's</span> personal details</span>

          <ul class="tabs tabs-partner" v-if="IncludePartner.value">
            <li class="tabs-title" :class="{ 'is-active': !showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: false })">You</a>
            </li>
            <li class="tabs-title" :class="{ 'is-active': showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: true })">Your partner</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <section>
      <div class="tabs-content">
        <div class="tabs-panel" :class="{ 'is-active': !showYourPartnerTab || !IncludePartner.value }">
          <personal-inputs></personal-inputs>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Include your partner? <help-icon message="Enter details for your partner in order to estimate your joint financial situation at retirement."></help-icon></label>
            </div>

            <div class="medium-6 columns text-right">
              <checkbox name="include-partner" :items="includePartners" :selected="IncludePartner" @change="actionIncludePartner({ value: $event.value })"></checkbox>
            </div>

            <div class="small-12 medium-2 columns"></div>
          </div>
        </div>

        <div class="tabs-panel" :class="{ 'is-active': showYourPartnerTab }" v-if="IncludePartner.value">
          <personal-inputs :modifier="partnerModifier"></personal-inputs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants } from '@/constants';

export default {
  components: {
    PersonalInputs: require('../../inputs/PersonalInputs').default,
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
      includePartners: {
        yes: {
          value: true,
          text: 'Yes',
        },
        no: {
          value: false,
          text: 'No',
        },
      },
    };
  },
  computed: {
    ...mapState(['inputs', 'ui']),
    showYourPartnerTab() {
      return this.ui.showYourPartnerTab.value;
    },
    IncludePartner() {
      return this.inputs.IncludePartner;
    },
  },
  methods: {
    ...mapActions([
      'actionIncludePartner',
      'actionShowYourPartnerTab',
    ]),
  },
};
</script>
